<template>
    <form>
        <img v-if="!this.img" class="rounded landing-info-img" @click="seleccionar"
            src="/img/default-avatar.jpg" alt="avatar">
        <img v-if="this.img" class="rounded landing-info-img" @click="seleccionar"
            :src="'/api/personas/' + this.avatar.id + '/avatar'" alt="avatar">
        <input hidden type="file" name="avatar" id="uploadAvatarInput" accept=".jpg,.jpeg,.png">
    </form>
</template>

<script>
import Axios from 'axios';
export default {
    props: [
        'post',
        'avatar',
        'editable',
        'idPersona'
    ],
    data() { return {
        img: null,
        tipoAlumno: ''
    }},
    mounted() {

        const vm = this;

        this.$on('openDialog', function() {
            $('#uploadAvatarInput').click();
        });

        $('#uploadAvatarInput').on('change', function (e) {
            const formData = new FormData();
            formData.append('avatar', e.target.files[0])
            vm.upload(formData);
        });
    },
    methods: {
        seleccionar() {
            if(this.editable !== true){
                this.$emit('openDialog');
            }
        },
        upload(data) {
           try {
             axios.post('/api/personas/' + this.avatar.id + '/avatar', data, {
                 headers: {'Content-Type': 'multipart/form-data'}
             }).then(res => {
                 location.reload();
             }).catch(e => {
                 console.log('error', e);
             });
           } catch (e) {
             
           } finally {

           }


        },
        getImg(){
            axios.get('/api/personas/' + this.avatar.id + '/avatar').then(res => {
                this.img = res.data;
            }).catch(e => {
                console.log(e)
            });
        }
    },
    watch: {
        avatar(newVal, oldVal){
            this.getImg()
            this.img = newVal;
        },
    }
}
</script>
